import { useQuery } from "@tanstack/react-query";

import { getTenantsPaginated } from "api/tenants";
import { queryKeys } from "./queryKeys";

import { PaginationTable } from "js/components/types";

interface UseGetTenantsPaginatedOptions {
  pagination: PaginationTable;
  enabled?: boolean;
}

export const useGetTenantsPaginated = (
  options: UseGetTenantsPaginatedOptions,
) => {
  const { pagination, enabled = true } = options;

  return useQuery({
    queryKey: queryKeys.tenants.list(pagination),
    queryFn: () => getTenantsPaginated(pagination),
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
};
